import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=4bc3c99a"
import script from "./Overview.vue?vue&type=script&lang=js"
export * from "./Overview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JienaLiu\\Documents\\bookingEngine\\BookingEngineFrontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bc3c99a')) {
      api.createRecord('4bc3c99a', component.options)
    } else {
      api.reload('4bc3c99a', component.options)
    }
    module.hot.accept("./Overview.vue?vue&type=template&id=4bc3c99a", function () {
      api.rerender('4bc3c99a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Overview.vue"
export default component.exports